import { compose, withProps } from 'recompose';
import { withScriptjs, withGoogleMap } from 'react-google-maps';

import { loadingElement, containerElement, mapElement } from 'modules/google-maps/elements';

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

const googleMapsEnhance = compose(
  withProps(({ containerElement: customContainerElement, mapElement: customMapElement }) => ({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&v=3.exp&libraries=geometry,drawing,places`,
    loadingElement,
    containerElement: customContainerElement ? customContainerElement : containerElement,
    mapElement: customMapElement ? customMapElement : mapElement,
  })),
  withScriptjs,
  withGoogleMap
);

export { googleMapsEnhance };
